import { createSelector } from 'reselect'
import API from '../../../utils/http/api'
import * as taskTypesDuck from '../../../store/shared/taskTypesDuck'

const REQUEST = 'steppingblocks/studentActivities/REQUEST'
const SUCCESS = 'steppingblocks/studentActivities/SUCCESS'
const FAILURE = 'steppingblocks/studentActivities/FAILURE'

const initialState = {
  requestStarted: false,
  requestEnded: false,
  error: null,
  results: [],
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        requestStarted: true,
        requestEnded: false,
        error: null,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: payload.results,
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    default:
      return _state
  }
}

// Action Performers
export const performRetrieveStudentActivities = () => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const { results } = await API.get('/activities/by_subordinates', {})
    dispatch({
      type: SUCCESS,
      payload: {
        results,
      },
    })
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: {
        error: error.message,
      },
    })
  }
}

// Selectors
const studentActivities = state => state.studentActivities

const getStudentActivities = createSelector(studentActivities, _ => _.results)

export const getStudentActivitiesWithTaskType = createSelector(
  [getStudentActivities, taskTypesDuck.getTaskTypesByType],
  (activities, types) =>
    Object.keys(activities).reduce((acc, key) => {
      acc[key] = activities[key].map(item => ({
          ...item,
          taskTypeName: types[item._id],
      }))
      return acc
    }, {}),
)



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/studentActivitiesDuck.js